/**
 * Static-translations for tr. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const tr = {
  'anon.heading_default': 'Misafir olarak devam et',
  'anon.try_again': 'Tekrar dene',
  'auth.back_to_login': 'Girişe dön',
  'auth.check_email_message': 'Onay kodu için e-postanızı kontrol edin.',
  'auth.check_email_title': 'E-postanızı kontrol edin',
  'auth.confirm_email_title': 'E-postanı doğrula',
  'auth.confirmation_code': 'Doğrulama kodu',
  'auth.continue_with_apple': 'Apple ile devam et',
  'auth.continue_with_facebook': 'Facebook ile devam et',
  'auth.continue_with_github': 'GitHub ile devam et',
  'auth.continue_with_google': 'Google ile devam et',
  'auth.create_account': 'Hesap oluştur',
  'auth.default_subtitle': 'Tüm özelliklere erişmek ve verilerinizi senkronize etmek için giriş yapın.',
  'auth.email': 'E-posta adresi',
  'auth.email_already_registered': 'Bu e-posta zaten kayıtlı. Aşağıdan şifrenizle veya kayıt olurken kullandığınız hesapla giriş yapın.',
  'auth.email_exists': 'Bu e-postaya ait bir hesap zaten var.',
  'auth.email_not_confirmed': 'Önce e-postanızı doğrulayın.',
  'auth.forgot_password': 'Şifrenizi mi unuttunuz?',
  'auth.forgot_password_title': 'Şifrenizi mi unuttunuz?',
  'auth.forgot_subtitle': 'E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.',
  'auth.generic_error': 'Bir şeyler ters gitti',
  'auth.have_account': 'Hesabınız var mı?',
  'auth.hide_password': 'Şifreyi gizle',
  'auth.identity_already_linked': 'Bu hesap zaten kayıtlı. Aşağıdan onunla giriş yapın.',
  'auth.invalid_credentials': 'Geçersiz e-posta veya şifre',
  'auth.invalid_otp': 'Kod geçersiz veya süresi dolmuş.',
  'auth.last_used': 'Son kullanılan · {email}',
  'auth.last_used_no_email': 'Son kullanılan',
  'auth.link_purchase_subheading': 'Erişiminizi korumak için satın alımı hesabınıza bağlayacağız.',
  'auth.log_in': 'Giriş yap',
  'auth.log_in_link': 'Giriş yap',
  'auth.login_continue_purchase': 'Satın almaya devam etmek için giriş yapın',
  'auth.network_error': 'Ağ hatası. Bağlantınızı kontrol edip tekrar deneyin.',
  'auth.no_account': 'Hesabınız yok mu?',
  'auth.or': 'veya',
  'auth.password': 'Şifre',
  'auth.passwords_mismatch': 'Şifreler eşleşmiyor',
  'auth.rate_limited': 'Çok fazla istek. Lütfen daha sonra tekrar deneyin.',
  'auth.repeat_password': 'Şifreyi tekrarla',
  'auth.reset_link_valid': 'Bağlantı 1 saat geçerlidir.',
  'auth.reset_password_title': 'Şifreyi sıfırla',
  'auth.reset_sent_message': 'Bu e-posta varsa, sıfırlama kodu gönderildi.',
  'auth.reset_sent_subtitle': 'Şifre sıfırlama bağlantısı gönderdik. E-postadaki talimatları izleyin.',
  'auth.restore_purchases_heading': 'Satın almaları geri yükle',
  'auth.restore_purchases_subheading': 'Satın alımlarınızı geri yüklemek için lütfen giriş yapın.',
  'auth.send_reset': 'Sıfırlama e-postası gönder',
  'auth.service_unavailable': 'Hizmet geçici olarak kullanılamıyor. Daha sonra tekrar deneyin.',
  'auth.show_password': 'Şifreyi göster',
  'auth.sign_out': 'Çıkış yap',
  'auth.sign_up': 'Kayıt ol',
  'auth.sign_up_link': 'Kayıt ol',
  'auth.signed_in': 'Giriş yapıldı',
  'auth.signin_failed': 'Giriş başarısız',
  'auth.signup_failed': 'Kayıt başarısız',
  'auth.verify': 'Doğrula',
  'auth.weak_password': 'Şifre çok zayıf.',
  'auth.welcome': 'Hoş geldiniz!',
  'auth.welcome_signup': 'Hoş geldiniz!',
  'cta.close': 'Kapat',
  'cta.continue': 'Devam et',
  'cta.get_lifetime_access': 'Ömür boyu erişim al',
  'cta.get_plan_daily': 'Günlük plan al',
  'cta.get_plan_monthly': 'Aylık plan al',
  'cta.get_plan_weekly': 'Haftalık plan al',
  'cta.get_plan_yearly': 'Yıllık plan al',
  'cta.start_trial': '{days} günlük ücretsiz denemeyi başlat',
  'modal.close_aria': 'Kapat',
  'modal.continue': 'Devam et',
  'modal.error_generic': 'Bir şeyler ters gitti',
  'modal.loading': 'Yükleniyor…',
  'modal.purchase_restored_subtitle': 'Her şey hazır — keyfini çıkarın!',
  'modal.purchase_restored_title': 'Tekrar hoş geldiniz',
  'modal.purchase_success_subtitle': 'Her şey hazır — keyfini çıkarın!',
  'modal.purchase_success_title': 'Ödeme alındı',
  'modal.verifying_subscription': 'Aboneliğiniz kontrol ediliyor…',
  'nav.back': '← Geri',
  'nav.back_aria': 'Geri',
  'offer.limited_time': 'Sınırlı süreli teklif',
  'payment.awaiting_title': 'Yeni sekmede ödemeyi tamamlayın',
  'payment.checking': 'Kontrol ediliyor…',
  'payment.ive_paid': 'Ödeme yaptım',
  'payment.open_checkout_again': 'Ödemeyi tekrar aç',
  'payment.open_checkout_button': 'Ödemeyi aç',
  'pricing.free_trial_days': '{days} günlük ücretsiz deneme',
  'pricing.included_per': 'Dahil edilen {interval}:',
  'pricing.interval.day': 'gün',
  'pricing.interval.lifetime_short': 'ömür boyu',
  'pricing.interval.month': 'ay',
  'pricing.interval.period': 'dönem',
  'pricing.interval.week': 'hafta',
  'pricing.interval.year': 'yıl',
  'pricing.money_back': '30 gün para iade garantisi',
  'pricing.most_popular': 'En popüler',
  'pricing.no_prices': 'Fiyat yok.',
  'pricing.plan_label.daily': 'GÜNLÜK PLAN',
  'pricing.plan_label.lifetime': 'ömür boyu',
  'pricing.plan_label.monthly': 'aylık plan',
  'pricing.plan_label.weekly': 'haftalık plan',
  'pricing.plan_label.yearly': 'yıllık plan',
  'pricing.plans_aria': 'Planlar',
  'session.contact_support': 'Destekle iletişime geç',
  'session.restore_purchases': 'Satın alımları geri yükle',
  'session.sign_out': 'Çıkış yap',
  'session.signed_in_as_prefix': 'Şu hesapla giriş yapıldı:',
  'session.signing_out': 'Çıkış yapılıyor…',
  'support.attachments_label': 'Ekler',
  'support.close_button': 'Kapat',
  'support.done_button': 'Tamam',
  'support.email_placeholder': 'E-postanızı girin',
  'support.heading': 'Destek',
  'support.instruction': 'Destek talebinizi göndermek için lütfen aşağıdaki formu doldurun.',
  'support.invalid_email': 'Geçersiz e-posta',
  'support.message_length': '1–5000 karakter',
  'support.message_placeholder': 'Mesajınızı girin',
  'support.required': 'Gerekli',
  'support.send_another': 'Başka bir talep gönder',
  'support.send_button': 'Gönder',
  'support.sending': 'Gönderiliyor…',
  'support.subject_length': '3–200 karakter',
  'support.subject_placeholder': 'Konuyu girin',
  'support.success_heading': 'Talep gönderildi',
  'support.success_message_prefix': 'Mesajınızı aldık ve şu adrese yanıt vereceğiz'
} as const;

export default tr;
